import { WorkOrderType } from "./WorkOrderType"

export const categories = [
    {
        rrp: 1594,
        left: [
            {
                title: 'Tyre Replacement',
                type: WorkOrderType.TyreReplacement,
                amount: 1160,
                count: 4,
            },
            {
                title: 'Brake Replacement',
                type: WorkOrderType.Brakes,
                amount: 1000,
                count: 2,
            },
            {
                title: 'Tyre Repair',
                type: WorkOrderType.TyreRepair,
                amount: 216,
                count: 6,
            }
        ],
        right: [
            {
                title: 'Wiper Blade Replacement',
                type: WorkOrderType.WiperBlades,
                amount: 172,
                count: 2,
            },
            {
                title: '12V Battery Replacement',
                type: WorkOrderType.Battery,
                amount: 340,
                count: 1,
            },
            {
                title: 'Key Fob Repair/Replacement',
                type: WorkOrderType.KeyFob,
                amount: 3520,
                count: 4,
            }
        ]
    },

    {
        rrp: 1639,
        left: [
            {
                title: 'Tyre Replacement',
                type: WorkOrderType.TyreReplacement,
                amount: 1160,
                count: 4,
            },
            {
                title: 'Brake Replacement',
                type: WorkOrderType.Brakes,
                amount: 970,
                count: 2,
            },
            {
                title: 'Tyre Repair',
                type: WorkOrderType.TyreRepair,
                amount: 216,
                count: 6,
            }
        ],
        right: [
            {
                title: 'Wiper Blade Replacement',
                type: WorkOrderType.WiperBlades,
                amount: 162,
                count: 2,
            },
            {
                title: '12V Battery Replacement',
                type: WorkOrderType.Battery,
                amount: 340,
                count: 1,
            },
            {
                title: 'Key Fob Repair/Replacement',
                type: WorkOrderType.KeyFob,
                amount: 1160,
                count: 4,
            }
        ]
    },

    {
        rrp: 1855,
        left: [
            {
                title: 'Tyre Replacement',
                type: WorkOrderType.TyreReplacement,
                amount: 1420,
                count: 4,
            },
            {
                title: 'Brake Replacement',
                type: WorkOrderType.Brakes,
                amount: 1840,
                count: 2,
            },
            {
                title: 'Tyre Repair',
                type: WorkOrderType.TyreRepair,
                amount: 252,
                count: 6,
            }
        ],
        right: [
            {
                title: 'Wiper Blade Replacement',
                type: WorkOrderType.WiperBlades,
                amount: 184,
                count: 2,
            },
            {
                title: '12V Battery Replacement',
                type: WorkOrderType.Battery,
                amount: 555,
                count: 1,
            },
            {
                title: 'Key Fob Repair/Replacement',
                type: WorkOrderType.KeyFob,
                amount: 4000,
                count: 4,
            }
        ]
    },

    {
        rrp: 2215,
        left: [
            {
                title: 'Tyre Replacement',
                type: WorkOrderType.TyreReplacement,
                amount: 4000,
                count: 4,
            },
            {
                title: 'Brake Replacement',
                type: WorkOrderType.Brakes,
                amount: 2000,
                count: 2,
            },
            {
                title: 'Tyre Repair',
                type: WorkOrderType.TyreRepair,
                amount: 324,
                count: 6,
            }
        ],
        right: [
            {
                title: 'Wiper Blade Replacement',
                type: WorkOrderType.WiperBlades,
                amount: 288,
                count: 2,
            },
            {
                title: '12V Battery Replacement',
                type: WorkOrderType.Battery,
                amount: 1000,
                count: 1,
            },
            {
                title: 'Key Fob Repair/Replacement',
                type: WorkOrderType.KeyFob,
                amount: 4000,
                count: 4,
            }
        ]
    }




]
